import React from 'react';

import Show from 'services/Show';
import { showDefaultSearchState } from 'services/constants';
import { formatDate } from 'services/utils';

import AbstractSearchForm from 'components/AbstractSearchForm';
import Autocomplete       from 'components/autocomplete';

function formatDateValue(date) {
  return date;
}

export default class ShowSearchForm extends AbstractSearchForm {

  constructor(props) {
    super(props);
    this.state.start_dates = [];
    this.defaultSearchState = showDefaultSearchState;
  }

  getSeachData() {
    Show.start_dates().then((start_dates) => {
      if (this.mounted) {
        this.setState( { start_dates } );
      }
    });
  }

  render() {
    const item = this.state.item;
    if (Object.keys(item).length < 1) return null;
    return (
      <form onSubmit={this.onSubmit} className="col-md-8 border p-3 rounded shadow-sm">
        <div className="row">
          <div className="col-sm-3">
            <label htmlFor="name">Название</label>
            <input id="name" name="name" className="form-control" value={item.name} onChange={this.propertyChanged} />
          </div>
          <div className="col-sm-3 mb-3">
            <label htmlFor="country_id">Дата выставки</label>
            <Autocomplete items={this.state.start_dates} name="starts_at" value={item.starts_at} 
            getValue={formatDateValue} getLabel={formatDate} onChange={this.propertyChanged} />
          </div>
          <div className="col-sm-3">
            <label>Регистрация</label>
            <div>
              <label>
                <input type="radio" name="closed" checked={item.closed === ''} value="" onChange={this.propertyChanged} />
                &nbsp; Все
              </label>
              &nbsp;
              <label>
                <input type="radio" name="closed" checked={item.closed === 'no'} value="no" onChange={this.propertyChanged} />
                &nbsp; Открыта
              </label>
              &nbsp;
              <label>
                <input type="radio" name="closed" checked={item.closed === 'yes'} value="yes" onChange={this.propertyChanged} /> 
                &nbsp; Закрыта
              </label>
            </div>
          </div>
          <div className="col-sm-1 ms-4">
            <label style={{width:'100%'}}>&nbsp;</label>
            <button type="submit" className="btn btn-primary">Искать</button>
          </div>
          <div className="col-sm-1">
            <label style={{width:'100%'}}>&nbsp;</label>
            <button onClick={this.clear} type="button" className="btn btn-default">Очистить</button>
          </div>
        </div>
      </form>
    )
  }
}
